var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: (_vm.height + "px")}),attrs:{"id":"app"}},[_c(_vm.currentComponent,{tag:"component",on:{"complete":_vm.progress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }